export const ProvidersAiExludedUrlsLoading = [
  'ai/validCredentials/OpenAI',
  'ia/logs/log-credencial/add',
  'ia/catalogos/iacredencial/add'
];